import { useMemo } from 'react';
import { useUsuario } from '../usuario/usuario.hook';
import { PerfilAluno } from '../usuario/usuario.types';
import { MatriculaAtivaHook } from './use-matricula-ativa.types';

// Hook que obtem a matrícula ativa do aluno (migrado (as-is) do disciplinas-frontend)
export const useMatriculaAtiva: MatriculaAtivaHook = () => {
  const { get } = useUsuario();

  const dadosAluno = useMemo(() => get<PerfilAluno>().aura.dados, [get]);

  const matriculaAtiva = useMemo(() => {
    return dadosAluno?.matriculas?.find(
      (matricula) => matricula.situacao.toUpperCase() === 'ATIVO' || matricula.situacao.toUpperCase() === 'FORMANDO',
    );
  }, [dadosAluno?.matriculas]);

  return matriculaAtiva;
};
